// extracted by mini-css-extract-plugin
export default {"wrapper":"Activities_wrapper__p1Q5l","root":"Activities_root__0OWjt"};